<template>
  <div class="home">
    <div v-for="(item,itemIndex) in diyItems" :key="itemIndex">
      <!-- 搜索框 -->
      <div v-if="item.type=='search'">
        <diysearch :itemIndex="itemIndex" :itemStyle="item.style" :params="item.params"></diysearch>
      </div>
      <!-- banner轮播 -->
      <div v-if="item.type === 'banner'">
        <diybanner
          :itemIndex="itemIndex"
          :itemStyle="item.style"
          :params="item.params"
          :datalist="item.data"
        ></diybanner>
      </div>

      <!-- 单图组 -->
      <div v-if="item.type === 'imageSingle'">
        <diyimageSingle :itemIndex=" itemIndex " :itemStyle=" item.style " :datalist=" item.data"></diyimageSingle>
      </div>

      <!-- 视频组 -->
      <div v-if="item.type === 'video'">
        <diyvideo :itemIndex=" itemIndex " :itemStyle=" item.style " :params=" item.params "></diyvideo>
      </div>

      <!-- 文章组 -->
      <div v-if="item.type === 'article'">
        <diyarticle :itemIndex=" itemIndex " :params=" item.params " :datalist=" item.data "></diyarticle>
      </div>

      <!-- 头条快报 -->
      <div v-if="item.type === 'special'">
        <diyspecial
          :itemIndex=" itemIndex "
          :itemStyle=" item.style "
          :params=" item.params "
          :datalist=" item.data "
        ></diyspecial>
      </div>

      <!-- 公告组 -->
      <div v-if="item.type === 'notice'">
        <diynotice :itemIndex=" itemIndex " :itemStyle=" item.style " :params=" item.params "></diynotice>
      </div>

      <!-- 空白组 -->
      <div v-if="item.type === 'blank'">
        <diyblank :itemIndex=" itemIndex " :itemStyle=" item.style "></diyblank>
      </div>

      <!-- 辅助线 -->
      <div v-if="item.type === 'guide'">
        <diyguide :itemIndex=" itemIndex " :itemStyle=" item.style "></diyguide>
      </div>

      <!-- 在线客服 -->
      <div v-if="item.type === 'service'">
        <diyservice :itemIndex=" itemIndex " :itemStyle=" item.style " :params=" item.params "></diyservice>
      </div>

      <!-- 富文本 -->
      <div v-if="item.type === 'richText'">
        <diyrichText :itemIndex=" itemIndex " :itemStyle=" item.style " :params=" item.params "></diyrichText>
      </div>

      <!-- 导航组 -->
      <div v-if="item.type === 'navBar'">
        <diynavBar :itemIndex=" itemIndex " :itemStyle=" item.style " :datalist=" item.data "></diynavBar>
      </div>

      <!-- 图片橱窗 -->
      <div v-if="item.type === 'window'">
        <diywindow :itemIndex=" itemIndex " :itemStyle=" item.style " :datalist=" item.data "></diywindow>
      </div>

      <!-- 商品组 -->
      <div v-if="item.type === 'goods'">
        <diygoods :itemIndex=" itemIndex " :itemStyle=" item.style " :datalist=" item.data "></diygoods>
      </div>

      <!-- 优惠券组 -->
      <div v-if="item.type === 'coupon'">
        <diycoupon :itemIndex=" itemIndex " :itemStyle=" item.style " :datalist=" item.data "></diycoupon>
      </div>

      <!-- 拼团商品 -->
      <div v-if="item.type === 'sharingGoods'">
        <diysharingGoods :itemIndex=" itemIndex " :itemStyle=" item.style " :datalist=" item.data "></diysharingGoods>
      </div>

      <!-- 线下门店 -->
      <div v-if="item.type === 'shop'">
        <diyshop :itemIndex=" itemIndex " :itemStyle=" item.style " :datalist=" item.data "></diyshop>
      </div>
    </div>
  </div>
</template>

<script>
import Swipe from "@/components/Swipe.vue";
import diysearch from "@/components/diy/diysearch.vue";
import diybanner from "@/components/diy/diybanner.vue";
import diyimageSingle from "@/components/diy/diyimageSingle.vue";
import diyvideo from "@/components/diy/diyvideo.vue";
import diyarticle from "@/components/diy/diyarticle.vue";
import diyspecial from "@/components/diy/diyspecial.vue";
import diynotice from "@/components/diy/diynotice.vue";
import diyblank from "@/components/diy/diyblank.vue";
import diyguide from "@/components/diy/diyguide.vue";
import diyservice from "@/components/diy/diyservice.vue";
import diyrichText from "@/components/diy/diyrichText.vue";
import diynavBar from "@/components/diy/diynavBar.vue";
import diywindow from "@/components/diy/diywindow.vue";
import diygoods from "@/components/diy/diygoods.vue";
import diycoupon from "@/components/diy/diycoupon.vue";
import diysharingGoods from "@/components/diy/diysharingGoods.vue";
import diyshop from "@/components/diy/diyshop.vue";
import { index } from "../../apis/https.js";
export default {
  components: {
    Swipe,
    diysearch,
    diybanner,
    diyimageSingle,
    diyvideo,
    diyarticle,
    diyspecial,
    diynotice,
    diyblank,
    diyguide,
    diyservice,
    diyrichText,
    diynavBar,
    diywindow,
    diygoods,
    diycoupon,
    diysharingGoods,
    diyshop
  },
  data() {
    return {
      diyItems: []
    };
  },
  created() {
    this.GetIndex();
  },
  methods: {
    GetIndex() {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      index()
        .then(res => {
          this.$toast.clear();
          this.diyItems = res.data.items;
        })
        .catch(e => {
          this.$toast.clear();
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/common.css");
@import url("../../style/skin.less");
.home {
  // margin-bottom: 50px;
}

.cont {
  margin: 0;
  padding: 0;
  margin-top: 54px;
  line-height: 1;
}

.main {
  margin: auto;
  width: 95%;
}
.main_goods {
  margin: 10px auto;
  padding: 10px;
  display: flex;
  height: 160px;
  background: @white;
  box-sizing: border-box;
}
.main_goods_left {
  display: flex;
  width: 40%;
  height: 100%;
  background: @white;
  align-items: center;
}
.main_goods_left image {
  display: block;
  width: 120px;
  height: 120px;
}
.main_goods_right {
  position: relative;
  width: 60%;
  height: 100%;
}
.main_goods_title {
  display: block;
  margin-top: 10px;
  width: 100%;
  font-size: 14px;
  line-height: 1.3;
  color: #333;
}
.main_goods_desc {
  position: absolute;
  left: 0px;
  top: 45px;
}
.main_goods_desc text {
  display: inline-block;
}
.desc_introduction {
  margin-top: 5px;
  line-height: 1.4;
  font-size: 12px;
  color: @text;
  width: 200px;
}
.desc_situation {
  font-size: 12px;
  line-height: 1.3;
  color: @text;
  margin-top: 5px;
}
.people {
  margin: 0 6.5px;
}
.cl-9 {
  color: #999;
}
.desc_footer {
  margin-top: 7.5px;
  font-size: 12px;
}
.desc_footer .price_x {
  margin-right: 12.5px;
  color: @text;
  font-size: 14px;
}
.desc_footer .price_y {
  text-decoration: line-through;
}
.settlement {
  position: absolute;
  right: 0px;
  bottom: 0px;
  line-height: 27.5px;
  text-align: center;
  font-size: 14px;
  border-radius: 20px;
  color: @white;
  background: @btn;
  box-shadow: 0px 2px 10px -2px @btn;
  border: none;
}
.header {
  display: flex;
  position: fixed;
  top: 0;
  width: 100%;
  height: 44px;
  color: #333;
  font-size: 14px;
  background: @white;
  border-bottom: 1px solid #e4e4e4;
  z-index: 100;
  overflow: hidden;
  white-space: nowrap;
}
.header scroll-view {
  height: 100%;
}
.cs {
  display: inline-block;
  padding: 0 7.6px;
  text-align: center;
  min-width: 20%;
  height: 43.5px;
  line-height: 44px;
  box-sizing: border-box;
}
.cs text {
  display: block;
  height: 100%;
}
.active text {
  color: @text;
  border-bottom: 1px solid @text;
}
.hide {
  display: none;
}
.show {
  display: block;
}
</style>